import { atom, selector } from 'recoil';
import { queryMessage } from '@/services/user';
import { ResponseData } from '@/utils/request';

export interface FunctionPermissionModule {
  path: string;
  title?: string;
  permissionList?: { code: string; name?: string }[];
  children?: FunctionPermissionModule[];
}

export interface AdminUser {
  id: string;
  createDate?: number;
  updateDate?: number;
  del?: boolean;
  userName: string;
  password?: string | null;
  admin?: boolean;
  funcMap?: Record<string, unknown>;
  functionList?: FunctionPermissionModule[];
  /** 后端下发的完整权限树（IFrontPermissionNode 结构），用于侧边栏菜单过滤 */
  permissionPathList?: import('@/@types/router.d').IFrontPermissionNode[];
}

export interface CurrentUser {
  id: number;
  name: string;
  avatar: string;
  roles: string[];
  adminUser?: AdminUser;
}

export const initialState: CurrentUser = {
  id: 0,
  name: '',
  avatar: '',
  roles: [],
};

export const userState = atom({
  key: 'userState',
  default: initialState,
});

export const userMessageState = selector({
  key: 'userMessageState',
  get: async () => {
    const response: ResponseData<number> = await queryMessage();
    const { data, code } = response;
    if (code !== 0) {
      throw response.msg;
    }
    return data || 0;
  },
});
